"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reduxFlash = require("redux-flash");

var _styles = require("@material-ui/core/styles");

var _Toast = _interopRequireDefault(require("../Toast"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MARGIN = '1rem';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    toastContainer: {
      display: 'flex',
      position: 'fixed',
      zIndex: 1400,
      flexDirection: function flexDirection(props) {
        return props.flexDirection || 'column-reverse';
      },
      bottom: function bottom(props) {
        return !props.top && !props.bottom ? MARGIN : props.bottom;
      },
      left: function left(props) {
        return !props.left && !props.right ? MARGIN : props.left;
      },
      top: function top(props) {
        return !props.top && !props.bottom ? undefined : props.top;
      },
      right: function right(props) {
        return !props.left && !props.right ? undefined : props.right;
      }
    },
    toast: {
      position: 'static',
      margin: '0.5rem 0'
    }
  };
});

var DisplayFlashToasts = function DisplayFlashToasts(_ref) {
  var flexDirection = _ref.flexDirection,
      bottom = _ref.bottom,
      left = _ref.left,
      top = _ref.top,
      right = _ref.right;
  var classes = useStyles({
    flexDirection: flexDirection,
    bottom: bottom,
    left: left,
    top: top,
    right: right
  });
  var flashMessages = (0, _reactRedux.useSelector)(_reduxFlash.getFlashMessages);
  var dispatch = (0, _reactRedux.useDispatch)();

  var dispatchRemoveMessage = function dispatchRemoveMessage(id) {
    return function () {
      return dispatch((0, _reduxFlash.removeMessage)(id));
    };
  };

  return _react.default.createElement("div", {
    className: classes.toastContainer
  }, flashMessages && flashMessages.map && flashMessages.map(function (flash) {
    var variant = flash.props && flash.props.variant;
    return _react.default.createElement(_Toast.default, {
      key: flash.id,
      className: classes.toast,
      message: flash.message,
      variant: flash.isError ? 'error' : variant,
      onClose: dispatchRemoveMessage(flash.id)
    });
  }));
};

DisplayFlashToasts.propTypes = {
  flexDirection: _propTypes.default.string,
  bottom: _propTypes.default.string,
  left: _propTypes.default.string,
  top: _propTypes.default.string,
  right: _propTypes.default.string
};
var _default = DisplayFlashToasts;
exports.default = _default;